// extracted by mini-css-extract-plugin
export var adjacentSlide = "_n7-9";
export var arrowButtonContainer = "_n7-5";
export var arrowButtonIcon = "_n7-6";
export var carouselArrowButton = "_n7-2";
export var carouselElementContainer = "_n7-1";
export var currentSlide = "_n7-8";
export var left = "_n7-3";
export var otherSlide = "_n7-a";
export var productCarouselContainer = "_n7-0";
export var right = "_n7-4";
export var sliderOverflow = "_n7-7";